import { useState } from "react";
import { Col, Collapse, Row } from "reactstrap";
import DropdownMenuDivider from "../../Menus/DropdownMenuDivider";
import CollapseButton from "../../../elements/CollapseButton";
import DropdownOptionWithIcon from "../../Menus/DropdownOptionWithIcon";
import StrUtils from "../../../utils/StrUtils";

interface Props {
  singleReference: { APIName: string; Fields: any[]; Name: string };
  onColumnAdd: any;
  searchValue: string;
}

// Component for adding Single Reference Fields to the table. (as Summary Fields)
const SingleReferenceSection = ({
  singleReference,
  onColumnAdd,
  searchValue,
}: Props) => {
  const [open, setOpen] = useState(false);

  if (!Array.isArray(singleReference?.Fields) || !singleReference?.Name)
    return null;

  // If search value is provided, and the name of the section or the fields don't contain the search value, don't render the section.
  if (
    searchValue &&
    !singleReference.Fields.some((f) =>
      f.Name.toLowerCase().includes(searchValue.toLowerCase())
    ) &&
    !singleReference.Name.toLowerCase().includes(searchValue.toLowerCase())
  ) {
    return null;
  }

  // If search value is provided, filter the fields to only those that contain the search value.
  const fields = searchValue
    ? singleReference.Fields.filter((f) =>
        f.Name.toLowerCase().includes(searchValue.toLowerCase())
      )
    : singleReference.Fields;

  return (
    <>
      <DropdownMenuDivider />
      <div
        className="d-flex align-items-center cursor-pointer"
        onClick={() => setOpen((prev) => !prev)}
      >
        <CollapseButton hidden={open} css="p-0 mr-0" onClick={undefined} />
        <h5 className="m-0 ">{singleReference.Name} Fields</h5>
      </div>
      <Collapse isOpen={open}>
        <Row className="align-items-center">
          {fields?.map((field, i) => {
            return (
              <Col
                key={field.APIName}
                xs="12"
                md="6"
                className={`${i % 2 === 0 ? "pr-md-1" : "pl-md-1"}`}
              >
                <DropdownOptionWithIcon
                  name={field?.Name}
                  onClick={(e) => {
                    if (typeof onColumnAdd == "function") {
                      e.preventDefault();
                      onColumnAdd(field, singleReference.APIName);
                    }
                  }}
                  icon={`${StrUtils.iconForField(field)} text-dark`}
                  actionIcon="mdi mdi-plus"
                />
              </Col>
            );
          })}
        </Row>
      </Collapse>
    </>
  );
};

export default SingleReferenceSection;
